import _ from 'lodash'
import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import ReactDataGrid from 'react-data-grid'
import 'react-table/react-table.css'
import {  videoblue,warning  } from "../../../utils/sitecolors"

export default class RankingSettings extends Component {
  constructor (props) {
    super(props)
		this.handleGridRowsUpdated  = this.handleGridRowsUpdated.bind(this)
  }
 
  /* setColumns()
  {
    const { rankingPoints } = this.props
    const columns = [...new Set(rankingPoints.map(a => a.numberOfTeams))]
    const _columns = new Array()
		//const width = 40
    _columns.push(
    {
      key: 'fin',
      name: 'FIN',
      width:35
    }) 
		const temp = columns.map(col => {
			return {
				key:col,
				name:col,
				width:40
      }
    })
    return _columns.concat(temp)
	} */
  getRandomDate = (start, end) => {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).toLocaleDateString();
  }
  rowGetter = (i) => {
    const { rankingpoints } = this.props
    const { rows } = rankingpoints
    return rows[i]
  }
  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
      console.log('Updating ', fromRow,toRow,updated)
    // let rows = this.state.rows.slice();

    // for (let i = fromRow; i <= toRow; i++) {
    //   let rowToUpdate = rows[i];

    //   let updatedRow = update(rowToUpdate, {$merge: updated});
    //   rows[i] = updatedRow;
    // }

    // this.setState({ rows });
  }
  render () {
    const { rowGetter } = this
    const { 
			tier,settingsseason,rankingpoints
    } = this.props
    const pointsAvailable = (rankingpoints != undefined) && (_.isEmpty(rankingpoints) == false)
   // console.log('Rendering rankingPoints',pointsAvailable)
    if( pointsAvailable)
    {
      const { rows,columns } = rankingpoints
      return (
        <div className='pull-left col-sm-12'>     
          <h4 style={{ color:videoblue }}> {settingsseason} Season Tier {tier} Ranking Points</h4>
          <ReactDataGrid
            columns={columns}
            rowGetter={rowGetter}
            rowsCount={rows.length}
            minHeight={2490}
            rowHeight={30}
          /> 
      </div>)
    }
    else
    {
       return( <div className='pull-left col-sm-12'>     
       <h4 style={{ color:warning }}><i className="fa fa-exclamation" aria-hidden="true" />&nbsp;{' '} No ranking points have been uploaded for {settingsseason} season, tier {tier}</h4>
      
   </div>)
    }
  }
}
RankingSettings.propTypes = {
	tier:PropTypes.string,
	rankingpoints:PropTypes.object,
	settingsseason:PropTypes.string
}


// WEBPACK FOOTER //
// ./src/containers/season/Components/RankingSettings.js